<template>
  <div class="table-skeleton mb-2">
    <p
      v-if="tableTitle"
      class="table-title"
    >
      {{ tableTitle }}
    </p>
    <v-skeleton-loader
      v-else
      type="heading"
    />
    <v-skeleton-loader
      :type="[
        'ossein', 'heading@6', 'table-row-divider@3', 'table-row']"
    />
  </div>
</template>

<script>
export default {
  name: 'TableSkeleton',
  props: {
    tableTitle: { type: String, default: '' },
  },
};
</script>

<style lang="less" scoped>
.table-skeleton {
  background: @white;
  padding: 24px;
  border-radius: 10px;
}

.table-skeleton :deep(.v-skeleton-loader) {
  border-radius: 0px;
}

.table-skeleton :deep(.v-skeleton-loader__heading) {
  width: 150px;
  max-width: 150px;
}

.table-skeleton :deep(.v-skeleton-loader__table-tfoot) {
  border-radius: 0px 0px 10px 10px;
}

.table-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
</style>
